const MAX_EPOCH_SECONDS = 1e11;

const toFiniteNumber = (value) => {
  if (typeof value === 'number') return Number.isFinite(value) ? value : null;
  if (typeof value === 'string' && value.trim()) {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  }
  return null;
};

const toEpochMs = (value) => {
  if (typeof value === 'number' && Number.isFinite(value)) {
    if (value <= 0) return null;
    return value < MAX_EPOCH_SECONDS ? Math.round(value * 1000) : Math.round(value);
  }
  if (typeof value === 'string' && value.trim()) {
    const numeric = Number(value);
    if (Number.isFinite(numeric)) return toEpochMs(numeric);
    const parsed = Date.parse(value);
    return Number.isNaN(parsed) ? null : parsed;
  }
  return null;
};

export const roundToDecimals = (value, decimals) => {
  if (decimals === undefined || !Number.isFinite(decimals)) return value;
  const factor = 10 ** decimals;
  return Math.round(value * factor) / factor;
};

export const normalizeBar = (raw, priceDecimals) => {
  const time = toEpochMs(raw?.timestamp);
  const open = toFiniteNumber(raw?.open);
  const high = toFiniteNumber(raw?.high);
  const low = toFiniteNumber(raw?.low);
  const close = toFiniteNumber(raw?.close);
  if (time === null || [open, high, low, close].some((value) => value === null || value <= 0)) {
    return null;
  }
  const volume = toFiniteNumber(raw?.volume);
  return {
    time,
    open: roundToDecimals(open, priceDecimals),
    high: roundToDecimals(Math.max(open, high, low, close), priceDecimals),
    low: roundToDecimals(Math.min(open, high, low, close), priceDecimals),
    close: roundToDecimals(close, priceDecimals),
    volume: volume !== null && volume >= 0 ? volume : undefined,
  };
};

export const normalizeBars = (rawBars, priceDecimals) => {
  const byTime = new Map();
  for (const raw of rawBars || []) {
    const bar = normalizeBar(raw, priceDecimals);
    if (bar) byTime.set(bar.time, bar);
  }
  return [...byTime.values()].sort((a, b) => a.time - b.time);
};

export const clampBarsToWindow = (bars, fromMs, toMs) =>
  bars.filter((bar) => bar.time >= fromMs && bar.time <= toMs);
